import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../entities';
import { TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import type { ThirdPartyConfig } from '../../schemas/3p-config';

import { LaunchDarklyIcon } from './icon';
import { LaunchDarklySearchResultIcon } from './search-result-icon';

export const launchDarklyConfig: ThirdPartyConfig = {
	displayName: 'LaunchDarkly',
	id: 'launchdarkly',
	resourceType: 'smartlinks-connector-launchdarkly',
	icon: get3PLogo(LaunchDarklyIcon, 'LaunchDarkly', 'medium'),
	searchResultIcon: get3PLogo(LaunchDarklySearchResultIcon, 'LaunchDarkly', 'large'),
	integrationAri: 'ari:cloud:platform::integration/launchdarkly',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.WorkItem,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
